<div class="container-send no-text-select" [@fadeInUp]>
    <div class="title">
        <!-- <p>Cliente del Grupo Onlygal</p> -->
        <p>Comprueba tu correo</p>
    </div>
    <div class="content">
        <p>Te hemos enviado un correo electrónico. <br> Comprueba tu buzón de entrada.</p>
    </div>
    <app-contact-line></app-contact-line>
</div>